
import { useEffect, useState } from 'react';
import Lenis from '@studio-freight/lenis';

const useLenis = () => {
  const [lenis, setLenis] = useState<Lenis | null>(null);//lenis instance stored
  // const smoothEasingQuint = (t: number) => -(Math.cos(Math.PI * t) - 1) / 2;
  // const smoothEsingExp = (t: number) => t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  const defaultLenisEasing = (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t));


  useEffect(() => {
    const lenisInstance = new Lenis({
      duration: 1.8,
      easing: defaultLenisEasing, // Example easing
    });

    setLenis(lenisInstance);
    function raf(time: number) {
      lenisInstance.raf(time);
      requestAnimationFrame(raf);
    } 

    requestAnimationFrame(raf);

    return () => {
      lenisInstance.destroy(); // Cleanup 
    };
  }, []);

  return lenis

};

export default useLenis;
